const actionTypes = {
  SET_SETTLED_BILL_LIST_LOADING: Symbol('SET_SETTLED_BILL_LIST_LOADING'),
  INIT_SETTLED_BILL_LIST: Symbol('INIT_SETTLED_BILL_LIST'),
};

export default actionTypes;
